import React from 'react';
import classnames from 'classnames';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import { useCurrentPromo } from '../../../utils/hooks/useCurrentPromo';
import { useCurrentUser } from '../../../utils/hooks/useCurrentUser';
import SaleBanner from '../../../SaleBanner';
import s from './UserGiftSaleBanner.scss';
/** A version of the SaleBanner specifically gifting an author from the DeviationPage */ const UserGiftSaleBanner = ({ className , user  })=>{
    const currentUser = useCurrentUser();
    const currentPromo = useCurrentPromo('gift');
    const currentUserIsRecipient = currentUser.userId === (user === null || user === void 0 ? void 0 : user.userId);
    const isRegularUser = (user === null || user === void 0 ? void 0 : user.type) === 'regular';
    if (currentUserIsRecipient || !isRegularUser || !currentPromo) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(SaleBanner, {
        className: classnames(s['root'], className),
        giftRecipient: user === null || user === void 0 ? void 0 : user.username,
        endDate: currentPromo === null || currentPromo === void 0 ? void 0 : currentPromo.endDate,
        discountValuePercent: currentPromo === null || currentPromo === void 0 ? void 0 : currentPromo.discountValuePercent,
        referralType: ReferralType.PROMOTION_BANNER_CONTENT_PAGE
    });
};
UserGiftSaleBanner.displayName = 'UserGiftSaleBanner';
export default UserGiftSaleBanner;
